import axios from 'axios';
import qs from 'qs';
import { Message,MessageBox } from 'element-ui'
// import nprogress from 'nprogress'
// nprogress.configure({ trickle: true,easing: 'ease', speed: 500 });

const config = {
  baseURL: process.env.VUE_APP_API,
  timeout: 30000, 
};

const _axios = axios.create(config);
// 添加请求前的返回拦截器
_axios.interceptors.request.use(
  (config:any) => {
    // nprogress.start();
		if(config.data) config.data = qs.stringify(config.data);
		// 在请求发送之前做一些处理
		if (!(/^https:\/\/|http:\/\//.test(config.url))) { 
			const token = window.localStorage.getItem('token')
			if (token && token !== 'undefined') {
				// 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
				config.headers['Authorization'] = `Bearer ${token}`
			}
		}
		config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
		return config
	},
	err => {
		// nprogress.done();
		Promise.reject(err)
	}
);
// console.log(APP)
// 添加数据返回的拦截器
_axios.interceptors.response.use(
  response => {
		// nprogress.done();
		// dataAxios 是 axios 返回数据中的 data
		const dataAxios = response.data
		// 这个状态码是和后端约定的
		const { code } = dataAxios
		// 根据 code 进行判断
		if (code === undefined) {
			// 如果没有 code 代表这不是项目后端开发的接口 比如可能是 D2Admin 请求最新版本
			return dataAxios
		} else {
			// 有 code 代表这是一个后端接口 可以进行进一步的判断
			switch (code) {
				case 0:
					// [ 示例 ] code === 0 代表没有错误
					return dataAxios.data
				case 402:
					const routename = window.APP.$route.name;
					const witlist = [ 'login' ];
					if(witlist.indexOf(routename) == -1) {
						return MessageBox.confirm('用户登录授权过期, 是否继续?', '提示', {
							confirmButtonText: '去登陆',
							cancelButtonText: '取消',
							showClose: false,
							closeOnPressEscape: false,
							closeOnClickModal: false,
							showCancelButton: false,
							type: 'error'
						}).then(()=>{
							window.APP.$router.push('/login');
						});
					}
					break
				case 500:
					window.APP.$message({  message: '服务器错误',type: 'warning' });
					break
				default:
					Message.error(response.data.message);
					return dataAxios;
			}
		}
	},
  err =>{
		// nprogress.done()
		Promise.reject(err)
	}
);

export default _axios;
